{
  "DATA_ASSISTANT": {
    "TITLE": "Data Assistant",
    "NEW_CONVERSATION": "+ New",
    "LOADING": "Loading...",
    "LOADING_MESSAGES": "Loading messages...",
    "THINKING": "Thinking...",
    "UNTITLED": "Untitled conversation",
    "NO_CONVERSATIONS": "No conversations yet. Click \"+ New\" to start.",
    "EMPTY_STATE": "Select a conversation or create a new one to start.",
    "SEND": "Send",
    "PLACEHOLDER": "What can I find out for you?",
    "SHOW_SQL": "Show SQL",
    "NO_ROWS": "No rows returned.",
    "DELETE": "\u00d7",
    "DELETE_CONFIRM": "Delete conversation",
    "DELETE_CONFIRM_DESCRIPTION": "Are you sure you want to delete this conversation? This action cannot be undone.",
    "DELETE_CONFIRM_YES": "Delete",
    "CHAT": "Chat",
    "REPORTS": "Reports",
    "SAVE_TO_REPORT": "Save to report",
    "NEW_REPORT": "New report",
    "REPORT_NAME": "Report name",
    "NO_REPORTS": "No saved reports yet",
    "REPORTS_EMPTY_STATE": "Select a report or create a new one.",
    "REPORT_SAVED": "Saved to report",
    "DELETE_REPORT_CONFIRM": "Delete report",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Are you sure you want to delete this report? All saved items will be removed.",
    "DELETE_ITEM_CONFIRM": "Remove item",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Are you sure you want to remove this item from the report?",
    "EXPORT_CSV": "Export CSV",
    "REFRESH": "Refresh",
    "QUERY_RUNNING": "Running query...",
    "QUERY_FAILED": "Query failed",
    "AUTO_REFRESH": "Auto-refresh",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 seconds",
    "AUTO_REFRESH_1M": "1 minute",
    "AUTO_REFRESH_5M": "5 minutes",
    "AUTO_REFRESH_10M": "10 minutes",
    "EDIT_MESSAGE": "Edit message",
    "RENAME_REPORT": "Rename report",
    "RENAME_ITEM": "Rename item",
    "MOVE_UP": "Move up",
    "MOVE_DOWN": "Move down",
    "COLLABORATORS": {
      "BUTTON": "Collaborators",
      "TITLE": "Report collaborators",
      "DESCRIPTION": "Choose which agents and teams can view this report.",
      "AGENTS": "Agents",
      "TEAMS": "Teams",
      "SELECT_AGENTS": "Select agents",
      "SELECT_TEAMS": "Select teams",
      "SAVE": "Save",
      "SAVED": "Collaborators updated",
      "SAVE_FAILED": "Failed to update collaborators"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Reports"
}
